import React from "react";
import { useStore } from "@/store/StoreContext";
import Diya from "./Diya";

export default function DiwaliIntro() {
  const { content } = useStore();
  return (
    <section data-testid="diwali-intro" className="relative mx-auto max-w-7xl px-5 py-12 sm:px-8 lg:py-16">
      <div className="reveal grid items-center gap-10 lg:grid-cols-[1fr_auto]">
        <div className="max-w-3xl text-center lg:text-left">
          <h2 className="font-display text-3xl font-medium italic tracking-tight text-[#8F6E1D] sm:text-4xl">
            {content?.intro_title || "The Festival of Lights, The Light Within"}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#6B5B45] sm:text-lg">
            {content?.intro_text}
          </p>
        </div>
        <div className="mx-auto flex items-end gap-1 lg:mx-0" aria-hidden="true">
          <div className="float-y" style={{ animationDelay: "0.8s" }}><Diya size={56} /></div>
          <div className="float-y"><Diya size={92} /></div>
          <div className="float-y" style={{ animationDelay: "1.6s" }}><Diya size={56} /></div>
        </div>
      </div>
      <div className="gold-rule mx-auto mt-10 w-48" />
    </section>
  );
}
